import NotesIcon from '@mui/icons-material/Notes';
import { transparentize } from 'color2k';
import styled, { css } from 'styled-components';
import type { ChipSize } from 'common/ui/Chip';
import { Colors } from 'styles';

export type MacroPillProps = {
  label?: React.ReactNode;
  size?: ChipSize;
  className?: string;
};

export function MacroPill({ label = 'Macro', size = 'md', className }: MacroPillProps) {
  return (
    <BaseMacroPill className={className} $size={size}>
      <MacroNotesIcon $size={size} />
      <MacroPillText>{label}</MacroPillText>
    </BaseMacroPill>
  );
}

const PILL_SIZE = {
  xs: css`
    gap: 0.3rem;
    padding: 0 0.5rem;
  `,
  sm: css`
    gap: 0.35rem;
    padding: 0.15rem 0.6rem;
  `,
  md: css`
    gap: 0.4rem;
    padding: 0.15rem 0.7rem;
  `,
  lg: css`
    gap: 0.4rem;
    padding: 0.2rem 0.8rem;
  `,
} as const;

const PILL_ICON_SIZE = {
  xs: css`
    width: 1.1rem;
    height: 1.1rem;
  `,
  sm: css`
    width: 1.2rem;
    height: 1.2rem;
  `,
  md: css`
    width: 1.25rem;
    height: 1.25rem;
  `,
  lg: css`
    width: 1.3rem;
    height: 1.3rem;
  `,
} as const;

const BaseMacroPill = styled.span<{ $size: ChipSize }>`
  display: inline-flex;
  align-items: center;
  ${({ $size }) => PILL_SIZE[$size]}
  border-radius: 999px;
  background: ${transparentize(Colors.gray1, 0.2)};
  color: ${Colors.gray10};
  white-space: nowrap;
  flex-shrink: 0;
`;

const MacroPillText = styled.span`
  font-size: inherit;
  line-height: inherit;
`;

const MacroNotesIcon = styled(NotesIcon)<{ $size: ChipSize }>`
  && {
    ${({ $size }) => PILL_ICON_SIZE[$size]}
  }
`;
